module.exports = __webpack_public_path__ + "img/property_1_starter.af9c7fb0.jpg";